import type { JSX } from 'react';
import { Outlet } from 'react-router';
import { UnitProvider } from '../units/UnitContext';
import { UnitSwitcher } from '../units/UnitSwitcher';

/** Header with the unit switcher plus the routed content. Must sit inside `RequireOwner`. */
export const OwnerLayout = (): JSX.Element => (
  <UnitProvider>
    <main className="ow-page">
      <header className="ow-header">
        <img className="ow-logo" src="/icons/inhouse-trimmed.svg" alt="" />
        <span className="ow-title">Invite Owner</span>
        <UnitSwitcher />
      </header>
      <Outlet />
    </main>
  </UnitProvider>
);
